var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],ref:"ele",class:['multi-media-financial-report-gap', _vm.skinStr]},[_c('div',{staticClass:"gap-up"}),_vm._v(" "),_c('div',{staticClass:"gap-down"})])}
var staticRenderFns = []

export { render, staticRenderFns }